// Company data
export const CompanyName = 'Mistress Sammi Smith';
export const ContactEmailAddress = 'Sammislammy1969@gmail.com';
export const DirectorName = 'Sammi Smith';
export const LocationCity = 'Edison, NJ';
export const ServiceArea = 'New Jersey / New York / Pennsylvania';

export const CompanyTagLine = `Available in ${LocationCity}`;
export const MainTitle = 'Professional TS Dominatrix';
export const SubtitleMain = 'Bringing pleasure to submissives!';
export const SubtitleSecondary = `How can ${CompanyName} help you? `;

export const KeywordsPages = `Mistress Sammi Smith, Transsexual Dominatrix ${LocationCity}, TS Mistress ${LocationCity}, BDSM, Femdom, Professional Dominatrix ${LocationCity}, Fetish, Submission, Sissification, Pegging, Findom, Strap-on Play, Latex Mistress, Dungeon Sessions, TS Dominatrix, Forced Femme, Roleplay Domination`;

// Cookie data
export const NumberOfCookies = 0;
export const COOKIE_TIMER = 15000;
export const CookiePolicyName = 'CookiePolicy';

// URL
export const FULL_BUSINESS_URL = 'https://www.mistress-sammi-smith.co.uk';
export const SHORT_BUSINESS_URL = 'mistress-sammi-smith.co.uk';
export const DISPLAY_BUSINESS_URL = 'www.mistress-sammi-smith.co.uk';

export const FETLIFE_URL = 'https://fetlife.com/users/6993997';
export const ONLYFANS_URL = 'https://onlyfans.com/sammismith26';
export const MANYVIDS_URL =
  'https://www.manyvids.com/Profile/1003193633/Sammi_Smith/Store/Videos/';
export const TWITTER_URL = 'https://x.com/sammi_slammy';
export const REDDIT_URL = 'https://www.reddit.com/user/Buchabricks';
export const BOOKING_EMAIL = 'Sammislammy1969@gmail.com';

// Bot Data
export const BotName = 'Jerry';

// Social Media Services
export const FACEBOOK_SERVICE = 'facebook';
export const INSTAGRAM_SERVICE = 'instagram';
export const GOOGLE_SERVICE = 'google';
export const GITHUB_SERVICE = 'github';
export const APPLE_SERVICE = 'apple';
export const X_SERVICE = 'x';

// Social Media URLs
export const FACEBOOK_URL = 'https://facebook.com/';
export const INSTAGRAM_URL = 'https://instagram.com/';
export const GOOGLE_URL = 'https://google.com/';
export const GITHUB_URL = 'https://github.com/';
export const APPLE_URL = 'https://apple.com/';
export const X_URL = 'https://x.com/';

